import ApplicationSubHeading from '@/components/Elements/Heading/ApplicationSubHeading';
import { Typography } from 'antd';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const MortgagePage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/mortgage/purchase');
  }, []);
  return (
    <div>
      <ApplicationSubHeading title="Mortgage Page" />
    </div>
  );
};

export default MortgagePage;
